export default __webpack_public_path__ + "static/media/multiBTC.a623fea0.webp";